class listCtrl {
    constructor($scope, $uibModal, httpRequest, logger) {
        $scope.resData = []
        $scope.autoExpenseNameCount = 1
        $scope.autoExpenseName = function autoExpenseName() {
            let duplicateNameflag = true
            for ($scope.autoExpenseNameCount = 1; duplicateNameflag; $scope.autoExpenseNameCount++) {
                for (const i of $scope.resData) {
                    if (`报销类型${$scope.autoExpenseNameCount}` === i.expenseName && i.state != 0) {
                        duplicateNameflag = true
                        break
                    }
                    duplicateNameflag = false
                }
            }
            return `报销类型${--$scope.autoExpenseNameCount}`
        }
        $scope.toggleChange = function toggleChange(item) {
            item.toggle = !item.toggle
        }

        function queryList() {
            httpRequest.get_getIvatBxPzDTOList(true).then((res) => {
                $scope.resData = res.data.value
            })
        }
        queryList()

        httpRequest.get_dictByTypeArr(['deduction_flag']).then((res) => {
            $scope.dictData = res.data.value
            // 抵扣标志加上抵扣
            if ($scope.dictData.deduction_flag) {
            	$scope.dictData.deduction_flag.forEach((x) => { x.enumName += '抵扣' })
            }
        })
        httpRequest.get_getIvatRuleConfList({
            ruleType: 'zclx',
        }).then((res) => {
            $scope.ivatRuleList = res.data.value
        })
        $scope.dedectionChange = function dedectionChange(obj) {
            if (obj.deductionFlag == 1) {
                obj.turnOutType = ''
                obj.red = false
            } else {
                obj.red = true
            }
        }
        $scope.turnOutTypeChange = function turnOutTypeChange(obj) {
            obj.red = false
        }
        $scope.add = function add() {
            if ($scope.resData.length > 1) {
                const len = $scope.resData.length - 1
                for (let i = 0; i < $scope.resData[len].mxList.length; i++) {
                    if (!$scope.resData[len].mxList[i].expenseName) {
                        logger.logError('请勿连续添加')
                        return
                    }
                }
            }
            $scope.resData.push({
                expenseName: $scope.autoExpenseName(),
                mxList: [{
                    deductionFlag: '1',
                    expenseName: '',
                    status: 0,
                    turnOutType: '',
                    updateEnable: 1,
                    state: 1,
                }],
                status: 0,
                updateEnable: 1,
                state: 1,
            })
        }
        $scope.deleteExpenseClass = function deleteExpenseClass(item, itemIndex) {
            if (!item.confId) {
                $scope.resData.splice(itemIndex, 1)
                return
            }
            item.state = 0
        }
        $scope.save = function save() {
            for (const i in $scope.resData) {
                const element = $scope.resData[i]
                if (element.state == 0) { // 删除标识
                    continue
                }
                if (!element.expenseName) {
                    logger.logError('新增项目不能为空')
                    return
                }
                let num = 0
                for (const j of $scope.resData) {
                    if (element.expenseName == j.expenseName && j.state != 0) num++
                }
                if (num > 1) {
                    logger.logError('项目名称不允许相同')
                    return
                }
                for (const x in element.mxList) {
                    const item = element.mxList[x]
                    if (item.state == 0) { // 删除标识
                        continue
                    }
                    if (!item.expenseName) {
                        logger.logError('新增项目不能为空')
                        return
                    } if (item.expenseName.length > 10) {
                        logger.logError('二级项目名称最多10个字符')
                        return
                    }
                    let count = 0
                    for (const y of element.mxList) {
                        if (item.expenseName == y.expenseName && y.state != 0) count++
                    }
                    if (count > 1) {
                        logger.logError('项目名称不允许相同')
                        return
                    }
                    if (item.deductionFlag != 1 && !item.turnOutType) {
                        logger.logError('不允许抵扣时，明细行第三项不能为空')
                        return
                    }
                }
            }
            httpRequest.post_saveIvatBxPzDTOList($scope.resData).then(() => {
                logger.logSuccess('保存成功')
            }).finally(() => {
                queryList()
            })
        }
        $scope.rename = function rename(item) {
            $uibModal.open({
                templateUrl: 'expenseCofigRename.html',
                openedClass: 'mod-modal mod-modal-md',
                controller: ['$scope', '$uibModalInstance', 'expenseName', 'logger', function ($scope, $uibModalInstance, expenseName, logger) {
                    $scope.expenseName = expenseName
                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel')
                    }
                    $scope.ok = function () {
                        if (!$scope.expenseName) {
                            $uibModalInstance.close(expenseName)
                            return
                        }
                        if ($scope.expenseName.length > 15) {
                            logger.logError('该类型名称最多15个字符')
                            return
                        }
                        $uibModalInstance.close($scope.expenseName)
                    }
                }],
                animation: true,
                resolve: {
                    expenseName() {
                        return item.expenseName
                    },
                },
            }).result.then((expenseName) => {
                item.expenseName = expenseName
            })
        }
        $scope.addDetail = function addDetail(item) {
            item.mxList.push({
                deductionFlag: '1',
                expenseName: '',
                status: 0,
                turnOutType: '',
                updateEnable: 1,
            })
        }
        // 删除细类
        $scope.deleteExpenseDetail = function deleteExpenseDetail(detail, detailIndex, item) {
            if (!detail.confId) {
                item.mxList.splice(detailIndex, 1)
                return
            }
            detail.state = 0
        }
        $scope.addName = function addName(item) {
            if (!this.temporaryName) {
                logger.logError('项目名称不能为空')
                return
            }
            if (this.temporaryName.length > 15) {
                logger.logError('项目名称最大15个字符')
                return
            }
            item.expenseName = this.temporaryName
            this.temporaryName = ''
        }
        $scope.swChange = function swChange(item) {
            if (item.status == 1) {
                item.mxList.forEach((o) => o.status = 0)
            }
        }
        $scope.swChildChange = function swChildChange(item, status) {
            if (status != 1) item.status = 1
            // httpRequest.post_updateIvatBxPzDTO(item)
        }
    }
}

listCtrl.$inject = ['$scope', '$uibModal', 'httpRequest', 'logger']

export default listCtrl



// WEBPACK FOOTER //
// ./src/app/input/basedata/expenseConfig/list.js